var result = require("!!../../../../node_modules/html-loader/index.js?interpolate!./styling_titles_bg.html")
var H = require("hogan.js");
window.Hogan = H;
module.exports = function() {
var T = H.compile(result, {});
return T.render.apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./node_modules/mustache-loader!./node_modules/html-loader?interpolate!./src/components/guideline/templates/styling_titles_bg.html
// module id = 85
// module chunks = 0